export default "/assets/images/technology-graph-06.c728ad6001ac0c0a.svg";